import * as R from 'ramda';
import moment from 'moment';

import { USER_ROLE } from '@/config/enum';

// 首字母大写
export const firstToUpper = str => str.replace(/( |^)[a-z]/g, L => L.toUpperCase());

// 根据state的名称列表自动生成mutation对象
export const generMutation = (stateNames) => {
  let mutationObj = {};

  R.forEach((stateName) => {
    mutationObj = R.assoc(`set${firstToUpper(stateName)}`
      , (state, payload) => { state[stateName] = payload; }
      , mutationObj);
  }, stateNames);
  return mutationObj;
};

export const secondToMs = (timeStamp) => Number(timeStamp + '000');

export const msToSecond = (timeStamp) => Number(R.dropLast(3, timeStamp.toString()));

// 秒时间戳差值相当于多少耗时
export const secondTimeStampDuration = ({ startTime, endTime }) => {
  if (!R.is(Number, startTime) || !R.is(Number, endTime)) return {};
  const duration = secondToMs(endTime - startTime);
  const d = parseInt(duration / (1000 * 60 * 60 * 24));
  const h = parseInt((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const min = parseInt((duration % (1000 * 60 * 60)) / (1000 * 60));
  const sec = (duration % (1000 * 60)) / 1000;
  return {
    d,
    h,
    min,
    sec,
  };
};

export const secondTimeStampText = (timestamp) => timestamp ? moment(secondToMs(timestamp)).format('YYYY-MM-DD HH:mm') : '';
/**
 * 毫秒 转 日期格式
 * @param timestamp
 * @returns {string}
 */
export const millisSecondTimeStampText = (timestamp) => timestamp ? moment(timestamp).format('YYYY-MM-DD HH:mm:ss') : '';

export const secondTimeStampDurationText = ({ startTime, endTime }) => {
  let text = '';
  const time = secondTimeStampDuration({ startTime, endTime });
  if (time) {
    const { d, h, min } = time;
    if (d) {
      text += `${d}天`;
    }
    if (h) {
      text += `${h}时`;
    }
    if (min) {
      text += `${min}分`;
    }
  }
  return text;
};

export const getItemsByProp = (props, data) => R.map((prop) => {
  return R.find(R.propEq('prop', prop), data);
}, props);

export const isDoc = (role) => {
  if (role && role !== USER_ROLE.DOCTOR) {
    return false;
  }
  return true;
};

export const isAgent = (role) => {
  if (role && role !== USER_ROLE.AGENT) {
    return false;
  }
  return true;
};

export const isCaptain = (role) => {
  if (role && role !== USER_ROLE.CAPTAIN) {
    return false;
  }
  return true;
};

export const isAdmin = (role) => {
  if (role && role !== USER_ROLE.ADMIN) {
    return false;
  }
  return true;
};

export const isWorker = (role) => {
  if (role && role !== USER_ROLE.WORKER) {
    return false;
  }
  return true;
};



// WEBPACK FOOTER //
// ./src/utils/index.js